/**
 * Custom link component which handles app redirects
 * as well as standard link behavior
 */

import React from 'react';
import PropTypes from 'prop-types';
import { navigateTo } from '../../../lib/helpers/navigation';
import { childrenType, navigateToOptionsType } from '../../../IbePropTypes';
import routes from '../../../constants/routes';

const propTypes = {
  children: childrenType,
  href: PropTypes.string,
  navigateOptions: navigateToOptionsType,
  className: PropTypes.string,
};

const defaultProps = {
  children: <></>,
  href: routes.sites,
  navigateOptions: { },
  className: '',
};

const Link = ({
  children,
  className,
  href,
  navigateOptions = {},
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    navigateTo(href, navigateOptions);
  };

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  );
};

Link.propTypes = propTypes;

Link.defaultProps = defaultProps;

export default Link;
